import { useEffect, useRef } from 'react';

import log from 'loglevel';

import { TAB_TO_VIEWTYPE_MAP } from './constants';
import { useSmartDataFetch } from './useSmartDataFetch';
import { TabId } from '../../components/InboxTabsFilter/constants';

export const useTabDataFetch = (
  activeTabId: TabId,
  emailAddresses?: string[],
  reloadKey?: number,
) => {
  const { fetchViewType } = useSmartDataFetch();
  const fetchViewTypeRef = useRef(fetchViewType);
  fetchViewTypeRef.current = fetchViewType;

  useEffect(() => {
    const fetchData = async () => {
      const viewTypeToFetch = TAB_TO_VIEWTYPE_MAP[activeTabId];

      if (viewTypeToFetch) {
        try {
          await fetchViewTypeRef.current(viewTypeToFetch, emailAddresses);
        } catch (error) {
          log.error(`Error fetching data for tab ${activeTabId}:`, error);
        }
      }
    };

    fetchData();
  }, [activeTabId, emailAddresses, reloadKey]);
};
